export default {
    computed: {
        usingIE() {
            if  (navigator.userAgent.indexOf('MSIE')!==-1
                || navigator.appVersion.indexOf('Trident/') > 0) {
                console.log('Internet Explorer Detected');
                return true;
            }
            return false;
        }
    },

    methods: {

        loadIETimePicker(callback) {
            let link = document.createElement('link');
            link.rel = 'stylesheet';
            link.href = '//cdnjs.cloudflare.com/ajax/libs/timepicker/1.3.5/jquery.timepicker.min.css';
            document.getElementsByTagName('head')[0].appendChild(link);

            $.getScript( "//cdnjs.cloudflare.com/ajax/libs/timepicker/1.3.5/jquery.timepicker.min.js", function( data, textStatus, jqxhr ) {
                // console.log('IE Timepicker Loaded');
                if (callback) callback();
            });

        }

    }
}